<div *ngIf="illustrationName" class="d-flex justify-content-center flex-column align-items-center mt-5 p-3 gap-flex">
  
  <ng-container *ngIf="!showMsgOnTop">
    <ng-container *ngTemplateOutlet="illustration"></ng-container>
  </ng-container>

  <p-messages [severity]="severity" *ngIf="text">
    <ng-template pTemplate>
      <div style=" font-weight: 300;"> {{text}} </div>
    </ng-template>
  </p-messages>
  
  <ng-container *ngIf="showMsgOnTop">
    <ng-container *ngTemplateOutlet="illustration"></ng-container>
  </ng-container>
  <!-- Shared img template -->
  <ng-template #illustration>
    <img [src]="'/assets/illustrations/' + illustrationName" [height]="height" width="100%">
  </ng-template>
</div>